import styled from "styled-components"

export const StyledOrder = styled.div`
  padding: 24px;
  border: 1px solid #000;
  font-family: "Times New Roman", Times, serif;
  font-size: 14px;
  margin-top: 42px;
  position: relative;
  
  .content{
    padding: 16px;
    
    .br{
      overflow: hidden;
      border-bottom: 1px solid #000;
      border-top: none;
      border-left: none;
      border-right: none;
      border-color: #000 !important;
      border-radius: 0 5px 5px 5px;
    }
    
    .b{
      border-bottom: 1px solid #000;
    }
    
    .ant-select{
      .ant-select-selector{
        border: none !important;
      }
    }
  }
  
  .footer{
    display: flex;
    justify-content: space-between;
  }
  
  .lang{
    margin: 0;
    background-color: #51258F;
    color: #fff;
    padding: 2px;
    position: absolute;
    top: -26px;
    left: 0;
  }
`